var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _rect3, _rect4, _path8, _rect5, _rect6, _rect7, _path9;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 28,
    viewBox: "0 0 39 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.577148,
    y: 25.1333,
    width: 37.7048,
    height: 2.21793,
    rx: 1.10897,
    fill: "#414142"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.42573 16.6313C2.83404 16.6313 3.16504 16.9623 3.16504 17.3707L3.16504 24.7638L1.68642 24.7638L1.68642 17.3707C1.68642 16.9623 2.01742 16.6313 2.42573 16.6313Z",
    fill: "#414142"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70975 18.479C10.343 18.479 11.667 19.803 11.667 21.4362L11.667 24.7631L5.75251 24.7631L5.75251 21.4362C5.75251 19.803 7.07651 18.479 8.70975 18.479Z",
    fill: "#414142"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9835 18.479C21.1064 18.479 22.0166 19.3893 22.0166 20.5121L22.0166 24.7631L17.9504 24.7631L17.9504 20.5121C17.9504 19.3893 18.8606 18.479 19.9835 18.479Z",
    fill: "#414142"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2822 22.5464L38.2822 24.7644L30.1498 24.7644L30.1498 22.5464C30.9483 23.0791 31.5397 23.0791 32.072 22.5464C32.2114 22.3653 32.3477 22.2174 32.4808 22.1029L33.7433 22.1029C33.8547 22.2174 33.963 22.3653 34.0682 22.5464C34.8666 23.5322 35.532 23.5322 36.0643 22.5464C36.485 21.9739 37.3722 21.9739 38.2822 22.5464Z",
    fill: "#414142"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7433 22.1029L32.4808 22.1029C32.939 21.7086 33.3598 21.7086 33.7433 22.1029Z",
    fill: "#414142"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2822 24.7644L38.2822 22.5464C37.3722 21.9739 36.485 21.9739 36.0643 22.5464C35.532 23.5322 34.8666 23.5322 34.0682 22.5464C33.963 22.3653 33.8547 22.2174 33.7433 22.1029L32.4808 22.1029C32.3477 22.2174 32.2114 22.3653 32.072 22.5464C31.5397 23.0791 30.9483 23.0791 30.1498 22.5464L30.1498 24.7644L38.2822 24.7644Z",
    fill: "#414142"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2822 24.7644L38.2822 22.5464C37.3722 21.9739 36.485 21.9739 36.0643 22.5464C35.532 23.5322 34.8666 23.5322 34.0682 22.5464C33.963 22.3653 33.8547 22.2174 33.7433 22.1029L32.4808 22.1029C32.3477 22.2174 32.2114 22.3653 32.072 22.5464C31.5397 23.0791 30.9483 23.0791 30.1498 22.5464L30.1498 24.7644L38.2822 24.7644Z",
    fill: "#414142"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0166,
    y: 12.5649,
    width: 4.06621,
    height: 4.06621,
    rx: 2,
    transform: "rotate(90 22.0166 12.5649)",
    fill: "#414142"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3018,
    y: 12.5649,
    width: 4.06621,
    height: 4.06621,
    rx: 2,
    transform: "rotate(90 28.3018 12.5649)",
    fill: "#414142"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3018,
    y: 18.8501,
    width: 4.06621,
    height: 4.06621,
    rx: 2,
    transform: "rotate(90 28.3018 18.8501)",
    fill: "#414142"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9921 5.17236C15.4004 5.17236 15.7314 5.50336 15.7314 5.91167L15.7314 24.7641L14.2528 24.7641L14.2528 5.91167C14.2528 5.50336 14.5838 5.17236 14.9921 5.17236Z",
    fill: "#414142"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5693,
    y: 8.84424,
    width: 16.78,
    height: 1.77065,
    rx: 0.885324,
    transform: "rotate(145.213 15.5693 8.84424)",
    fill: "#414142"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21.96,
    y: 2.10205,
    width: 9.58645,
    height: 1.77065,
    rx: 0.885324,
    transform: "rotate(145.213 21.96 2.10205)",
    fill: "#414142"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 34.335,
    y: 12.7271,
    width: 18.0332,
    height: 1.77152,
    rx: 0.885759,
    transform: "rotate(-144.347 34.335 12.7271)",
    fill: "#414142"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1054 10.3481C33.5137 10.3481 33.8447 10.6791 33.8447 11.0875L33.8447 18.4806L32.3661 18.4806L32.3661 11.0875C32.3661 10.6791 32.6971 10.3481 33.1054 10.3481Z",
    fill: "#414142"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logoBlack.f5d365752e41e5f8700ff63e9eb2dd83.svg";
export { ForwardRef as ReactComponent };